module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/015-2bcc97a853e416e89f8de6ced786420c.jpg";